module.exports = __webpack_public_path__ + "images/giftShadedIcon-07a502e4c07d885f7dc5b9c300ae8e34.svg";